import { SocieteSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const SocieteModel: SelectorModel = {
  name: 'societes',
  getSelector: SocieteSelectors.selectAllSocietesDictionary,
  isReady: SocieteSelectors.selectIsReadySociete
};
